// Slice 40 — sticky cyan-tinted staff stripe at the top of every screen.
// Reminds operators they are on the back-office; right side surfaces the
// host + a heartbeat status dot (Slice 47 swaps the dot for a real probe).

import { HqStatusDot, Icons } from "../ui";

export function StaffStripe() {
  return (
    <div
      className="hq-staff-stripe-bg"
      style={{
        height: 28,
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "0 16px",
        borderBottom: "1px solid var(--hq-border-staff)",
        fontSize: 10.5,
        color: "var(--hq-accent)",
        letterSpacing: ".1em",
        textTransform: "uppercase",
        fontFamily: "var(--hq-font-mono)",
        position: "sticky",
        top: 0,
        zIndex: 5,
        backdropFilter: "blur(4px)",
        background: "rgba(7,8,11,.55)",
      }}
    >
      <Icons.Shield width={10} height={10} sw={1.8} />
      <span>Staff back-office · not for production · all actions logged</span>
      <span style={{ flex: 1 }} />
      <span style={{ color: "var(--hq-text-dim)", textTransform: "none", letterSpacing: 0 }}>
        {typeof window !== "undefined" ? window.location.host : "license-server"}
      </span>
      <HqStatusDot tone="success" pulse size={6} />
    </div>
  );
}
